import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleImagePresenter',
  props: {
    cssClasses: { default: '' },
    imageUrl: null,
    altText: { default: '' },
    format: { default: 'jpg' },
    settings: { default: null },
    sizes: { default: () => [] },
    widths: { default: () => [] },
    heights: { default: () => [] },
    crop: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { cssClasses: string, imageUrl: string, altText: string, format: string, settings: IImageSizeSetting[] | null, sizes: string[], widths:(number | null)[], heights: (number | null)[], crop?: boolean }



function webpKey(index: number) { return Symbol(index + '_webp'); }
function imageKey(index: number) { return Symbol(index + props.format); }

const sizeSettings = computed<IImageSizeSetting[]>(() => {
    if (props.settings) {
        return props.settings;
    } else {
        const sizeNumbers = props.sizes.map(size => typeof size === 'number' ? size : parseInt(size, 10));

        const settings = [];
        const length = sizeNumbers.length;
        for (let i = 0; i <= length; i++) {
            settings.push({
                maxSize: i === length ? null : sizeNumbers[i] - 1,
                minSize: i === 0 ? null : sizeNumbers[i - 1],
                width: props.widths[i],
                height: props.heights[i]
            });
        }
        return settings;
    }
});

function getImageUrl(sizeSetting: IImageSizeSetting, format: string): string {
    let imageUrl = `${props.imageUrl}?format=${format}`;
    if (sizeSetting.width) {
        imageUrl += `&width=${sizeSetting.width}`;
    }
    if (sizeSetting.height) {
        imageUrl += `&height=${sizeSetting.height}`;
    }
    if (props.crop) {
        imageUrl += '&mode=crop';
    }
    return encodeURI(imageUrl);
}

function getImageMediaQuery(sizeSetting: IImageSizeSetting): string {
    if (sizeSetting.maxSize && !isNaN(sizeSetting.maxSize)) {
        return `(max-width: ${sizeSetting.maxSize}px)`;
    } else if (sizeSetting.minSize && !isNaN(sizeSetting.minSize)) {
        return `(min-width: ${sizeSetting.minSize}px)`;
    }
    return '';
}

function ensureSizeSetting(): IImageSizeSetting {
    return sizeSettings.value[0];
}

return { __sfc: true,props, webpKey, imageKey, sizeSettings, getImageUrl, getImageMediaQuery, ensureSizeSetting }
}

})